import { useMarketplaceLabel } from "../../configurazione/marketplaceDisplay";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import umanizzaDataSenzaOre from "../../../interfaccia/funzioniComuni/umanizzaDataSenzaOre";
import OrdineVoceCliccabile from "./OrdineVoceCliccabile";
import stilePulsanti from "../../../interfaccia/stilePulsanti";
import DataTable from "../../../interfaccia/DataTableBase";
import chickenLoading from "../../../files/img/chickenLoading.gif";
import ImgArt from "../OrdineComponenti/ImgArt";
import associaImmagineENomeANomeUtente from "../../../interfaccia/funzioniComuni/associaImmagineENomeANomeUtente";
import NotaTooltip from "./NotaTooltip";
import GaranziaVoceCliccabile from "./GaranziaVoceCliccabile";
import axios from "axios";
import apiUrl from "../../../Apiurl";
import { identificaColonneOrdini, ORDINI_COLUMN_IDS, ORDINI_LOCKED_COLUMN_IDS } from "./ordiniColumnMetadata";
import { normalizeColumnOrder } from "./columnOrder";
import "./colonneOrdini.css";

function ListaOrdini({
  perPageOptions,
  colonna,
  vista,
  setOrdineFunction,
  listaOrdini,
  righeSelezionate,
  setRigheSelezionate,
  loading,
  totalRows,
  handlePerRowsChange,
  handlePageChange,
  perPage,
  deseleziona,
  utente,
  handleSort,
  columnSort,
  directionSort,
  mobile,
  ricerca,
  page,
  setGaranzia,
  funzioneScegliID,
  report,
  ordiniColumnVisibility,
  ordiniColumnOrder,
  onOrdiniColumnOrderChange,
  enableOrdiniColumns,
}) {
  const marketplaceLabel = useMarketplaceLabel();
  const tableRef = useRef(null);
  const [rows, setRows] = useState(listaOrdini);
  const [pendingCells, setPendingCells] = useState([]); // array di row.id
  const [errorCells, setErrorCells] = useState([]); // array di row.id
  const [copiedValues, setCopiedValues] = useState([]);
  const [copiedValuesNOW, setCopiedValuesNOW] = useState();
  let expandableRows = false;
  let expandableRowsComponent;
  let rowPreExpanded = (row) => false;
  let paginationRowsPerPageOptions = perPageOptions;
  let pagineDefault = perPage;
  let striped = true;
  let selectableRows = true;
  let fixedHeader = false;
  let fixedHeaderScrollHeight = "100px";
  let expandOnRowClicked = false;
  let expandOnRowDoubleClicked = false;
  let expandableRowsHideExpander = false;

  const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };

    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  useEffect(() => {
    setRows(listaOrdini);
  }, [listaOrdini, vista, perPage, totalRows, columnSort, directionSort]);

  useEffect(() => {
    console.log("state", righeSelezionate);
  }, [righeSelezionate]);

  const handleChangeRigheSelezionate = useCallback((state) => {
    setRigheSelezionate(state.selectedRows);
  }, []);

  const dataMinoreDiOggi = function (data) {
    if (!data) {
      console.log("no data");
      return false;
    }
    const date1 = new Date(data);
    const date2 = new Date();
    if (date1 > date2) {
      return false;
    } else if (date1 < date2) {
      return true;
    } else {
      return false;
    }
  };

  const switchaBool = async (row, tabella, campoIDTabella, campo, nomeDato) => {
    // Aggiorna subito la cella (ottimistico)
    setRows((prevRows) =>
      prevRows.map((r) =>
        r.id === row.id ? { ...r, [nomeDato]: r[nomeDato] === 1 ? 0 : 1 } : r,
      ),
    );
    setPendingCells((prev) => [...prev, row.id]);
    setErrorCells((prev) => prev.filter((id) => id !== row.id));
    try {
      await axios.patch(
        apiUrl + "/setValueSQL",
        {
          tabella: tabella,
          campo: campo,
          nuovoValore: row[nomeDato] === 1 ? 0 : 1,
          wheresComeRicercaDB: {
            [campoIDTabella + " ="]: row.id,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      );
      setPendingCells((prev) => prev.filter((id) => id !== row.id));
    } catch (err) {
      // Se errore, mostra segnale di errore e ripristina il valore
      setErrorCells((prev) => [...prev, row.id]);
      setPendingCells((prev) => prev.filter((id) => id !== row.id));
      setRows((prevRows) =>
        prevRows.map((r) =>
          r.id === row.id ? { ...r, [nomeDato]: row[nomeDato] } : r,
        ),
      );
    }
  };

  /////////////////// FUNZIONI COLONNE ////////////////////////////////

  const colonnaUniversale = function (
    nomeDato,
    labelDato,
    width,
    sortable,
    hide,
    reorder,
    conditionalCellStyles,
    ignoreRowClick,
    sortField,
    compact,
  ) {
    return {
      selector: (row) => row[nomeDato],
      ...(nomeDato === "Market_Place" ? { format: row => marketplaceLabel(row[nomeDato]) } : {}),
      name: labelDato,
      sortable: sortable,
      hide: hide,
      reorder: reorder,
      width: width + "px",
      conditionalCellStyles: conditionalCellStyles,
      ignoreRowClick: ignoreRowClick,
      sortField: sortField,
      compact: compact,
    };
  };

  const nomeClientePS = function (
    nomeDato,
    labelDato,
    width,
    idSped,
    sortField,
    compact,
    conditionalCellStyles,
  ) {
    return {
      selector: (row) => row[nomeDato],
      name: labelDato,
      sortable: true,
      ignoreRowClick: true,
      /* sortFunction: caseInsensitiveSort, */
      reorder: true,
      compact: compact ? true : false,
      width: width + "px",
      sortField: sortField,
      conditionalCellStyles: conditionalCellStyles,
      cell: (row) => {
        if (righeSelezionate.length < 1) {
          return (
            <div className="rowitem">
              <OrdineVoceCliccabile
                setOrdineFunction={setOrdineFunction}
                idSped={row[idSped]}
                datoDisplay={
                  <div className="flex items-center">
                    <span className="dn db-ns">
                      {stilePulsanti.tastoApriAspetto}
                    </span>
                    <span className="b ml2">{row[nomeDato]}</span>
                  </div>
                }
              />
            </div>
          );
        } else {
          return <span className="b ml2">{row[nomeDato]}</span>;
        }
      },
    };
  };

  const scegliID = function (
    nomeDato,
    labelDato,
    width,
    idSped,
    sortField,
    compact,
    conditionalCellStyles,
  ) {
    return {
      selector: (row) => row[nomeDato],
      name: labelDato,
      sortable: true,
      ignoreRowClick: true,
      reorder: true,
      compact: compact ? true : false,
      width: width + "px",
      sortField: sortField,
      conditionalCellStyles: conditionalCellStyles,
      cell: (row) => {
        return (
          <div className="rowitem">
            <button
              className={stilePulsanti.buttonClassesWhite}
              onClick={() =>
                funzioneScegliID(row.id, "idSpedOriginale", 2, "ordine", row)
              }
            >
              SCEGLI
            </button>
          </div>
        );
      },
    };
  };

  const colonnaUniversaleConCopiaValore = function (
    nomeDato,
    labelDato,
    width,
    sortable,
    hide,
    reorder,
    conditionalCellStyles,
    ignoreRowClick,
    sortField,
    compact,
  ) {
    return {
      selector: (row) => row[nomeDato],
      name: labelDato,
      sortable: sortable,
      hide: hide,
      reorder: reorder,
      width: width + "px",
      conditionalCellStyles: conditionalCellStyles,
      ignoreRowClick: ignoreRowClick,
      sortField: sortField,
      compact: compact,
      cell: (row) => {
        const isCopied = copiedValues.includes(row.id);
        let classString = "ml2";
        if (row.id === copiedValuesNOW) {
          classString += " b blue";
        } else if (isCopied) {
          classString += " green";
        }
        if (row.moda_venduto && row.moda_venduto === 1) {
          classString += " strike";
        }
        return (
          <div
            className="rowitem pointer"
            onClick={(e) => {
              navigator.clipboard.writeText(row[nomeDato]);
              setCopiedValuesNOW(row.id);
              setCopiedValues((prev) => [...prev, row.id]);
            }}
          >
            <span className={classString}>{row[nomeDato]}</span>
          </div>
        );
      },
    };
  };

  /* onClick={(e) => switchaBoolGenerico(ordineTemp.spedEclifor[0]["Promemoria"], "spedEclifor[0].Promemoria") */

  const garanziaCliccabile = function (
    nomeDato,
    labelDato,
    width,
    id,
    sortField,
    compact,
    conditionalCellStyles,
  ) {
    return {
      selector: (row) => row[nomeDato],
      name: labelDato,
      sortable: true,
      ignoreRowClick: true,
      /* sortFunction: caseInsensitiveSort, */
      reorder: true,
      compact: compact ? true : false,
      width: width + "px",
      sortField: sortField,
      conditionalCellStyles: conditionalCellStyles,
      cell: (row) => {
        let nomeCliente;
        if (row[nomeDato]) {
          nomeCliente = row[nomeDato];
        } else if (row["nomeClienteLibero"]) {
          nomeCliente = row["nomeClienteLibero"];
        } else {
          nomeCliente = "Nuova garanzia";
        }

        if (righeSelezionate.length < 1) {
          return (
            <div className="rowitem">
              <GaranziaVoceCliccabile
                setGaranzia={setGaranzia}
                idGaranzia={row[id]}
                datoDisplay={
                  <div className="flex items-center">
                    <span className="dn db-ns">
                      {stilePulsanti.tastoApriAspetto}
                    </span>
                    <span className="b ml2">{nomeCliente}</span>
                  </div>
                }
              />
            </div>
          );
        } else {
          return <span className="b ml2">{row[nomeDato]}</span>;
        }
      },
    };
  };

  const descrizioneArticolo = function (nomeDato, labelDato, width, sortField) {
    return {
      selector: (row) => row[nomeDato],
      name: labelDato,
      sortable: true,
      ignoreRowClick: true,
      /* sortFunction: caseInsensitiveSort, */
      reorder: true,
      width: width + "px",
      sortField: sortField,
      cell: (row) => {
        const codVS =
          row["codVS"] ??
          row["Cod Viglietti Sport"] ??
          row["codiceVS"] ??
          row["codice_vs"];
        return (
          <ModaDescrizioneCell
            valore={row[nomeDato]}
            codVS={codVS}
            token={token}
          />
        );
      },
    };
  };

  const normalizzaCodiceStatoModa = (codice) =>
    codice === null || codice === undefined ? "" : String(codice).trim();

  const statiModaConosciuti = {
    0: {
      label: "NUOVA",
      tipo: "dot",
      dotClassName: "colPreparazione",
    },
    10: {
      label: "DISPONIBILE",
      tipo: "icon",
      icon: "check_circle",
      iconClassName: "green",
    },
    20: {
      label: "NON DISP.",
      tipo: "icon",
      icon: "cancel",
      iconClassName: "red",
    },
    30: {
      label: "Sped. att. incasso",
      tipo: "dot",
      dotClassName: "colAttesa",
    },
    40: {
      label: "VENDUTO",
      tipo: "dot",
      dotClassName: "colSpedito",
      dotStyle: { backgroundColor: "var(--colScrittaSpedito)" },
      labelClassName: "colSpedito ph1 br1",
    },
    50: {
      label: "ANNULLATA",
      tipo: "dot",
      dotClassName: "colAnnullato",
    },
  };

  const renderStatoModaCompatto = (codice, descrizione) => {
    const codiceNormalizzato = normalizzaCodiceStatoModa(codice);
    const stato = statiModaConosciuti[codiceNormalizzato];
    if (!stato) {
      return <span>{descrizione || codiceNormalizzato || ""}</span>;
    }

    return (
      <div
        className="flex items-center"
        title={
          descrizione
            ? `${codiceNormalizzato} - ${descrizione}`
            : codiceNormalizzato
        }
      >
        {stato.tipo === "icon" ? (
          <span
            className={`material-icons f5 mr1 ${stato.iconClassName || ""}`}
          >
            {stato.icon}
          </span>
        ) : (
          <span
            className={`dib br-100 mr2 ${stato.dotClassName || ""}`}
            style={{
              width: "0.9rem",
              height: "0.9rem",
              flexShrink: 0,
              ...(stato.dotStyle || {}),
            }}
          />
        )}
        <span className={stato.labelClassName || ""}>{stato.label}</span>
      </div>
    );
  };

  const statoWebModa = function (width) {
    return {
      selector: (row) => row.moda_stato_web_codice,
      name: "Stato Moda",
      sortable: true,
      ignoreRowClick: true,
      reorder: true,
      width: width + "px",
      sortField: "a.moda_stato_web_codice",
      cell: (row) => {
        const codice = row.moda_stato_web_codice;
        const descrizione = row.moda_stato_web_descrizione;
        if (!codice && !descrizione) {
          return <span className="gray">-</span>;
        }
        return <div className="rowitem">{renderStatoModaCompatto(codice, descrizione)}</div>;
      },
    };
  };

  const statoWebModaOrdine = function (width) {
    return {
      selector: (row) => row.moda_stato_web_descrizione_ordine,
      name: "Stato Moda",
      sortable: true,
      ignoreRowClick: true,
      reorder: true,
      width: width + "px",
      sortField: "statiModaOrdine.moda_stato_web_descrizione_ordine",
      cell: (row) => {
        const codice = row.moda_stato_web_codice_ordine;
        const descrizione = row.moda_stato_web_descrizione_ordine;
        const diversi =
          codice === "STATI DIVERSI" || descrizione === "STATI DIVERSI";
        if (!codice && !descrizione) {
          return <span className="gray">-</span>;
        }
        return (
          <div className="rowitem">
            {diversi ? (
              <div className="dib br2 bg-light-yellow dark-red b ph2 pv1">
                STATI DIVERSI
              </div>
            ) : (
              <>{renderStatoModaCompatto(codice, descrizione)}</>
            )}
          </div>
        );
      },
    };
  };

  const colonnaFlagArticoliOrdine = function (
    nomeDato,
    labelDato,
    width,
    sortField,
  ) {
    return {
      selector: (row) => row[nomeDato],
      name: labelDato,
      sortable: true,
      ignoreRowClick: true,
      reorder: true,
      width: width + "px",
      sortField: sortField,
      cell: (row) => {
        const valore = row[nomeDato];
        if (!valore) {
          return <span className="gray">-</span>;
        }
        if (valore === "MISTO") {
          return (
            <div className="dib br2 bg-light-yellow dark-red b ph2 pv1">
              MISTO
            </div>
          );
        }
        return (
          <div
            className={
              "dib br2 b ph2 pv1 " +
              (valore === "SI"
                ? "bg-light-green dark-green"
                : "bg-light-gray gray")
            }
          >
            {valore}
          </div>
        );
      },
    };
  };

  const ModaDescrizioneCell = ({ valore, codVS, token }) => {
    const [modaInfo, setModaInfo] = useState(null);
    const [loadingModa, setLoadingModa] = useState(false);
    const [erroreModa, setErroreModa] = useState("");
    const [copiedModaValue, setCopiedModaValue] = useState("");

    useEffect(() => {
      setModaInfo(null);
      setErroreModa("");
    }, [codVS]);

    const copiaValoreModa = useCallback(async (value) => {
      if (!value) return;
      try {
        await navigator.clipboard.writeText(String(value));
        setCopiedModaValue(String(value));
        setTimeout(() => setCopiedModaValue(""), 1500);
      } catch (error) {
        console.error("Copia fallita", error);
      }
    }, []);

    const fetchModa = useCallback(async () => {
      if (!codVS || modaInfo || loadingModa || !token) return;
      setLoadingModa(true);
      setErroreModa("");
      try {
        const response = await axios.get(
          `${apiUrl}/moda/articoli/${encodeURIComponent(codVS)}`,
          {
            headers: { Authorization: "Bearer " + token },
          },
        );
        if (response?.data?.data) {
          setModaInfo(response.data.data);
        } else {
          setErroreModa("Nessun dato Moda");
        }
      } catch (error) {
        setErroreModa(error?.message || "Errore dati Moda");
      } finally {
        setLoadingModa(false);
      }
    }, [codVS, modaInfo, loadingModa, token]);

    return (
      <div className="rowitem mb3 mt2">
        <div className="flex items-center">
          <div className="mr2">{valore}</div>
          <button
            type="button"
            className={`${stilePulsanti.buttonClassesWhite} pv1 mr2`}
            onClick={fetchModa}
            disabled={!codVS || loadingModa}
            style={{ height: "30px" }}
          >
            <span className="material-icons f6 v-mid">search</span>
          </button>
        </div>
        <div className="flex items-center mt1">
          {loadingModa && <span className="gray f7">Caricamento…</span>}
          {erroreModa && <span className="dark-red f7 ml2">{erroreModa}</span>}
          {copiedModaValue && (
            <span className="gray f7 ml2">Copiato: {copiedModaValue}</span>
          )}
        </div>
        {modaInfo && (
          <div className="w-100 mt2 ba b--black-10 br2 pa2 bg-washed-blue">
            <div className="flex flex-wrap">
              <button
                type="button"
                className="mr3 mb2 bg-transparent bn tl pointer"
                onClick={() => copiaValoreModa(modaInfo.codProd ?? "-")}
                title="Copia valore"
              >
                <div className="gray f7">Cod. Prod.</div>
                <div className="b underline-hover">
                  {modaInfo.codProd ?? "-"}
                </div>
              </button>
              <button
                type="button"
                className="mr3 mb2 bg-transparent bn tl pointer"
                onClick={() => copiaValoreModa(modaInfo.codMod ?? "-")}
                title="Copia valore"
              >
                <div className="gray f7">Cod. Mod.</div>
                <div className="b underline-hover">
                  {modaInfo.codMod ?? "-"}
                </div>
              </button>
              <button
                type="button"
                className="mr3 mb2 bg-transparent bn tl pointer"
                onClick={() => copiaValoreModa(modaInfo.codCol ?? "-")}
                title="Copia valore"
              >
                <div className="gray f7">Cod. Col.</div>
                <div className="b underline-hover">
                  {modaInfo.codCol ?? "-"}
                </div>
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const immagineUtente = function (
    nomeDato,
    labelDato,
    width,
    sortField,
    displayNome,
    compact,
  ) {
    return {
      selector: (row) => row[nomeDato],
      name: labelDato,
      sortable: true,
      ignoreRowClick: true,
      reorder: true,
      width: width + "px",
      sortField: sortField,
      compact: { compact },
      cell: (row) => {
        if (row[nomeDato]) {
          const { pathImmagine, nomeDisplay } = associaImmagineENomeANomeUtente(
            row[nomeDato],
            utente.username,
          );
          let widthImm = 100;
          let padding = 1;
          if (displayNome) {
            widthImm = 40;
          }
          if (compact) {
            padding = 1;
          }
          return (
            <div
              className={
                "flex flex-wrap items-center w-100 justify-around h3 pa" +
                padding
              }
            >
              <div className={"h-100 pa0 tc w-" + widthImm}>
                <img
                  src={pathImmagine}
                  className="br-100 h-100 dib"
                  alt="foto utente"
                ></img>
              </div>
              {displayNome && <div className="ml2 w-50 b">{nomeDisplay}</div>}
            </div>
          );
        } else {
          return;
        }
      },
    };
  };

  const noteToolTipAvatarUtenti = function (nomeDato, labelDato, width) {
    return {
      selector: (row) => row[nomeDato],
      name: labelDato,
      sortable: false,
      ignoreRowClick: true,
      /* sortFunction: caseInsensitiveSort, */
      reorder: true,
      width: width + "px",
      cell: (row) => {
        return row[nomeDato].map((nota) => {
          return (
            <NotaTooltip
              nomeUtente={nota.nomeUtente}
              utente={utente}
              dataNota={nota.dataNota}
              contenuto={nota.contenuto}
            />
          );
        });
      },
    };
  };

  const colonnaData = function (
    nomeDato,
    labelDato,
    width,
    sortField,
    compact,
  ) {
    return {
      selector: (row) => row[nomeDato],
      name: labelDato,
      sortable: true,
      sortField: sortField,
      reorder: true,
      width: width + "px",
      compact: { compact },
      format: (row) => {
        if (row[nomeDato] == null) {
          return "";
        }
        return `${umanizzaDataSenzaOre(row[nomeDato])}`;
      },
    };
  };

  const colonnaImporto = function (nomeDato, labelDato, width, sortField) {
    return {
      selector: (row) => row[nomeDato],
      name: labelDato,
      sortable: true,
      reorder: true,
      sortField: sortField,
      width: width + "px",
      format: (row) => {
        if (row[nomeDato] == null) {
          return "";
        }
        const number = parseFloat(row[nomeDato]);
        const numComma = number.toString().replace(".", ",");
        return `${numComma} €`;
      },
    };
  };

  const colonnaBoolean = function (
    nomeDato,
    labelDato,
    width,
    icon1,
    icon0,
    sortField,
    colIcon,
    cellStyles,
    noCompact,
  ) {
    return {
      selector: (row) => row[nomeDato],
      name: labelDato,
      sortable: true,
      sortField: sortField,
      reorder: true,
      compact: noCompact ? false : true,
      width: width + "px",
      conditionalCellStyles: cellStyles,
      format: (row) => {
        if (row[nomeDato] == null || row[nomeDato] === 0) {
          return icon0;
        } else {
          return <div class={"rowitem material-icons " + colIcon}>{icon1}</div>;
        }
      },
    };
  };

  const colonnaFileControlloCorrispettivi = function () {
    return {
      selector: (row) => row.file_controllo_corrispettivi,
      name: "File controllo corr.",
      sortable: false,
      ignoreRowClick: true,
      reorder: true,
      width: "220px",
      wrap: true,
      cell: (row) => {
        if (!row.file_controllo_corrispettivi) {
          return <span className="colScrittaDef-20">-</span>;
        }
        return <span className="b">{row.file_controllo_corrispettivi}</span>;
      },
    };
  };

  const colonnaConfermaControlloCorrispettivi = function () {
    return {
      selector: (row) => row.controllo_corrispettivi_stato_ordine,
      name: "Reg.",
      sortable: false,
      ignoreRowClick: true,
      reorder: true,
      width: "95px",
      compact: true,
      cell: (row) => {
        if (!row.file_controllo_corrispettivi) {
          return <span className="colScrittaDef-20">-</span>;
        }
        if (Number(row.controllo_corrispettivi_stato_ordine) === 3) {
          return (
            <span className="material-icons green" title="Confermato">
              check_circle
            </span>
          );
        }
        if (Number(row.controllo_corrispettivi_stato_ordine) === 1) {
          return (
            <span className="material-icons gray" title="Da ignorare">
              remove_circle
            </span>
          );
        }
        return (
          <span className="material-icons orange" title="In attesa conferma">
            pending
          </span>
        );
      },
    };
  };

  const colonnaBooleanSenzaNull = function (
    nomeDato,
    labelDato,
    width,
    icon1,
    icon0,
    sortField,
    colIcon1,
    colIcon0,
    nonSortable,
  ) {
    return {
      selector: (row) => row[nomeDato],
      name: labelDato,
      sortable: !nonSortable, //metto il contrario del valore in arg così posso mettere true solo su quelli che aggiungoi adesso
      sortField: sortField,
      reorder: true,
      compact: true,
      width: width + "px",
      format: (row) => {
        if (row[nomeDato] === 0) {
          return (
            <div class={"rowitem material-icons b " + colIcon0}>{icon0}</div>
          );
        } else if (row[nomeDato] == null) {
          return "";
        } else {
          return (
            <div class={"rowitem material-icons b " + colIcon1}>{icon1}</div>
          );
        }
      },
    };
  };

  const colonnaBooleanSenzaNullMODIFICA = function (
    nomeDato,
    labelDato,
    width,
    icon1,
    icon0,
    sortField,
    colIcon1,
    colIcon0,
    nonSortable,
    nomeCampoInTabella,
    campoIDTabella,
    tabella,
  ) {
    return {
      selector: (row) => row[nomeDato],
      name: labelDato,
      sortable: !nonSortable, //metto il contrario del valore in arg così posso mettere true solo su quelli che aggiungoi adesso
      sortField: sortField,
      reorder: true,
      compact: true,
      width: width + "px",
      format: (row) => {
        if (row[nomeDato] === 0) {
          return (
            <div
              class={"rowitem material-icons pointer b " + colIcon0}
              onClick={() =>
                switchaBool(
                  row,
                  tabella,
                  campoIDTabella,
                  nomeCampoInTabella,
                  nomeDato,
                )
              }
            >
              {icon0}
            </div>
          );
        } else if (row[nomeDato] == null) {
          return "";
        } else {
          return (
            <div
              class={"rowitem material-icons pointer b " + colIcon1}
              onClick={() =>
                switchaBool(
                  row,
                  tabella,
                  campoIDTabella,
                  nomeCampoInTabella,
                  nomeDato,
                )
              }
            >
              {icon1}
            </div>
          );
        }
      },
    };
  };

  const colonnaImmagine = function (
    nomeDato,
    labelDato,
    width,
    sizeIMG,
    compact,
  ) {
    return {
      selector: (row) => row[nomeDato],
      name: labelDato,
      sortable: false,
      reorder: true,
      compact: compact,
      width: width + "px",
      cell: (row) => {
        const imageCodVS = row["codVS"] || row["Cod Viglietti Sport"] || row["codiceVS"];
        if (imageCodVS || (row["prodIDps"] && row[nomeDato])) {
          return (
            <div className="rowitem">
              <OrdineVoceCliccabile
                setOrdineFunction={setOrdineFunction}
                idSped={row["idSped"]}
                datoDisplay={
                  <ImgArt
                    prodIDps={row["prodIDps"]}
                    imgIDps={row[nomeDato]}
                    size={sizeIMG}
                    fonte={row["fonte"]}
                    codVS={imageCodVS}
                    token={token}
                    zoomable={false}
                  />
                }
              />
            </div>
          );
        } else {
          return (
            <div className="rowitem">
              <OrdineVoceCliccabile
                setOrdineFunction={setOrdineFunction}
                idSped={row["idSped"]}
                datoDisplay={
                  <span className="">{stilePulsanti.tastoApriAspetto}</span>
                }
              />
            </div>
          );
        }
      },
    };
  };

  /* const colonnaArrayDiStringhe = function (nomeDato, labelDato, width, sortable, hide, reorder, conditionalCellStyles, ignoreRowClick, sortField, classSpan, compact) {
    return ({
      selector: row => row[nomeDato],
      name: labelDato,
      sortable: sortable,
      hide: hide,
      reorder: reorder,
      width: width + "px",
      conditionalCellStyles: conditionalCellStyles,
      ignoreRowClick: ignoreRowClick,
      sortField: sortField,
      compact: compact,
      cell: (row) => {
        if (row[nomeDato] && Array.isArray(row[nomeDato])) {
          return (
            <div>
              {row[nomeDato].map((dato,i)=><span className={classSpan}>{dato}{row[nomeDato].length>1 && row[nomeDato].length !== i+1 && ", "}</span>)}
            </div>
          )
        }
      }
    })
  } */

  const colonnaArrayDiArticoli = function (
    nomeDato,
    labelDato,
    width,
    sortable,
    hide,
    reorder,
    conditionalCellStyles,
    ignoreRowClick,
    sortField,
    icon1,
    icon0,
    colIcon1,
    colIcon0,
    compact,
  ) {
    return {
      selector: (row) => row[nomeDato],
      name: labelDato,
      sortable: sortable,
      hide: hide,
      reorder: reorder,
      width: width + "px",
      conditionalCellStyles: conditionalCellStyles,
      ignoreRowClick: ignoreRowClick,
      sortField: sortField,
      compact: compact,
      cell: (row) => {
        if (row[nomeDato] && Array.isArray(row[nomeDato])) {
          return (
            <div className="w-100">
              {row[nomeDato].map((dato, i) => {
                let bordino = " bb bordoColAlt";
                if (row[nomeDato].length === i + 1) {
                  bordino = "";
                }
                return (
                  <div className={"flex w-100 pa2 items-center" + bordino}>
                    <div className="w-20">
                      {dato.trovato === 0 && (
                        <div class={"rowitem material-icons b " + colIcon0}>
                          {icon0}
                        </div>
                      )}
                      {dato.trovato === null && ""}
                      {dato.trovato === 1 && (
                        <div class={"rowitem material-icons b " + colIcon1}>
                          {icon1}
                        </div>
                      )}
                    </div>
                    <div className="w-70">{dato.descA}</div>
                  </div>
                );
              })}
            </div>
          );
        }
      },
    };
  };

  const colonnaArrayDiNote = function (
    nomeDato,
    labelDato,
    width,
    sortable,
    hide,
    reorder,
    conditionalCellStyles,
    ignoreRowClick,
    sortField,
    compact,
  ) {
    return {
      selector: (row) => row[nomeDato],
      name: labelDato,
      sortable: sortable,
      hide: hide,
      reorder: reorder,
      width: width + "px",
      conditionalCellStyles: conditionalCellStyles,
      ignoreRowClick: ignoreRowClick,
      sortField: sortField,
      compact: compact,
      cell: (row) => {
        if (row[nomeDato] && Array.isArray(row[nomeDato])) {
          return (
            <div className="w-100">
              {row[nomeDato].map((dato, i) => {
                const { pathImmagine, nomeDisplay } =
                  associaImmagineENomeANomeUtente(
                    dato["nomeUtente"],
                    utente.username,
                  );
                let bordino = " bb bordoColAlt";
                if (row[nomeDato].length === i + 1) {
                  bordino = "";
                }
                return (
                  <div className={"flex w-100 pa2 items-center" + bordino}>
                    <div className="w-20 h3">
                      <img
                        src={pathImmagine}
                        className="br-100 h-100 dib"
                        alt="foto utente"
                      ></img>
                    </div>
                    <div className="w-70">
                      <div className="b">{nomeDisplay}</div>
                      <div>{dato.contenuto}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        }
      },
    };
  };

  /////////////////// RIQUADRI ESPANDIBILI ////////////////////////////////

  const expandedRowArticoloMobile = ({ data }) => {
    return (
      <div className="pa2 pl3 bb bordoColAlt pb3 mb4 bw3">
        <h3>{data["N_rif_PrestaShop"] + " - " + data["nomeCognome"]}</h3>
        <pre className="">{data["desc"]}</pre>
      </div>
    );
  };

  const expandedRowOrdineMobile = ({ data }) => {
    return (
      <div className="pa2 pl3 bb bordoColAlt pb3 mb4 bw3">
        <h3>{data["N_rif_PrestaShop"] + " - " + data["nomeCliente"]}</h3>
        <p>
          <span className="b mr2">Nome cliente</span>
          {data["nomeCliente"]}
        </p>
        <p>
          <span className="b mr2">Nome destinatario</span>
          {data["nomeCognomeSpedizione"]}
        </p>
        <p>
          <span className="b mr2">Società</span>
          {data["societa"]}
        </p>
        <p>
          <span className="b mr2">C/O</span>
          {data["co"]}
        </p>
        <p>
          <span className="b mr2">Località</span>
          {data["city"]}
        </p>
        <p>
          <span className="mr2">{data["CAP"]} </span>
          <span className="mr2">{data["Provincia"]} </span> {data["city"]}
        </p>
      </div>
    );
  };

  /////////////////// REGOLE STILI CELLE ////////////////////////////////

  const statoOrdineCellstyles = [
    {
      when: (row) =>
        row["Stato_Ordine"] === "IN ATTESA" &&
        row["Tipo"] !== "Invio per sostituzione" &&
        row["Tipo"] !== "Da controllare",
      classNames: ["colAttesa"],
    },
    {
      when: (row) =>
        row["Stato_Ordine"] === "IN ATTESA" &&
        row["Tipo"] === "Invio per sostituzione",
      classNames: ["colAttesaSost"],
    },
    {
      when: (row) =>
        row["Stato_Ordine"] === "TROVATO" &&
        row["Partenza_da"] !== "Prato Nevoso" &&
        row["Tipo"] !== "Da controllare",
      classNames: ["colTrovato"],
    },
    {
      when: (row) =>
        row["Stato_Ordine"] === "TROVATO" &&
        row["Partenza_da"] === "Prato Nevoso" &&
        row["Tipo"] !== "Da controllare",
      classNames: ["colTrovatoPrato"],
    },
    {
      when: (row) =>
        row["Stato_Ordine"] === "SPEDITO" && row["Tipo"] !== "Da controllare",
      classNames: ["colSpedito"],
    },
    {
      when: (row) =>
        row["Stato_Ordine"] === "PREPARAZIONE" &&
        row["Tipo"] !== "Da controllare",
      classNames: ["colPreparazione"],
    },
    {
      when: (row) =>
        row["Stato_Ordine"] === "ETICHETTE" && row["Tipo"] !== "Da controllare",
      classNames: ["colEtichette"],
    },
    {
      when: (row) =>
        row["Stato_Ordine"] === "PRONTO EXP" &&
        row["Tipo"] !== "Da controllare",
      classNames: ["colProntoExp"],
    },
    {
      when: (row) =>
        row["Stato_Ordine"] === "ANNULLATO" && row["Tipo"] !== "Da controllare",
      classNames: ["colAnnullato"],
    },
    {
      when: (row) =>
        row["Stato_Ordine"] === "IN ATTESA BB" &&
        row["Tipo"] !== "Da controllare",
      classNames: ["colBonifico"],
    },
    {
      when: (row) =>
        row["Stato_Ordine"] === "RESO" && row["Tipo"] !== "Da controllare",
      classNames: ["colReso"],
    },
    {
      when: (row) =>
        row["Stato_Ordine"] === "RESO - WARRANTY" &&
        row["Tipo"] !== "Da controllare",
      classNames: ["colResoW"],
    },
    {
      when: (row) =>
        row["Stato_Ordine"] === "RICERCA" && row["Tipo"] !== "Da controllare",
      classNames: ["colRicerca"],
    },
    {
      when: (row) =>
        row["Stato_Ordine"] === "DS-ORDINARE" &&
        row["Tipo"] !== "Da controllare",
      classNames: ["colDSordinare"],
    },
    {
      when: (row) =>
        row["Stato_Ordine"] === "DS-ORDINATO" &&
        row["Tipo"] !== "Da controllare",
      classNames: ["colDSordinato"],
    },
    {
      when: (row) => row["Tipo"] === "Da controllare",
      classNames: ["colAttesaControllare"], // LO SLEGO DALLE ATTESE
    },
  ];

  const marketplaceCellStyles = [
    {
      when: (row) => row["Market_Place"] === "Amazon",
      classNames: ["cellaStatoMP", "colAMZ"],
    },
    {
      when: (row) => row["Market_Place"] === "PrestaShop - vs.com",
      classNames: ["cellaStatoMP", "colPS"],
    },
    {
      when: (row) => row["Market_Place"] === "Prestahop - Botteroski",
      classNames: ["cellaStatoMP", "colFonteBOT"],
    },
    {
      when: (row) => row["Market_Place"] === "Colizey",
      classNames: ["cellaStatoMP", "colColizey"],
    },
    {
      when: (row) => row["Market_Place"] === "E-bay",
      classNames: ["cellaStatoMP", "colEBay"],
    },
    {
      when: (row) => row["Market_Place"] === "ePrice",
      classNames: ["cellaStatoMP", "colePrice"],
    },
    {
      when: (row) => row["Market_Place"] === "Store - Prato Nevoso",
      classNames: ["cellaStatoMP", "colNegPN"],
    },
    {
      when: (row) => row["Market_Place"] === "Store - Torino Jolly",
      classNames: ["cellaStatoMP", "colNegTO"],
    },
  ];

  const fonteCellStyles = [
    {
      when: (row) => row["fonte"] === "VIG",
      classNames: ["cellaFonteOrdine", "colFonteVIG"],
    },
    {
      when: (row) => row["fonte"] === "BOT",
      classNames: ["cellaFonteOrdine", "colFonteBOT"],
    },
  ];

  const magPartenzaConflittoCellStyles = [
    {
      when: (row) => Number(row["mag_partenza_conflitto"]) === 1,
      classNames: ["colAnnullato"],
    },
  ];

  const corriereCellStyles = [
    {
      when: (row) => row["Corriere"] === "BRT",
      classNames: ["cellaStatoCorriere", "colBRT"],
    },
    {
      when: (row) => row["Corriere"] === "DPD",
      classNames: ["cellaStatoCorriere", "colBRT"],
    },
    {
      when: (row) => row["Corriere"] === "DHL",
      classNames: ["cellaStatoCorriere", "colDHL"],
    },
    {
      when: (row) => row["Corriere"] === "UPS",
      classNames: ["cellaStatoCorriere", "colUPS"],
    },
    {
      when: (row) => row["Corriere"] === "GLS",
      classNames: ["cellaStatoCorriere", "colGLS"],
    },
    {
      when: (row) => row["Corriere"] === "SDA",
      classNames: ["cellaStatoCorriere", "colSDA"],
    },
  ];

  const statoMagCellStyles = [
    {
      when: (row) =>
        row["Corriere"] === "DPD" && row["stato"] === "PRONTO PER BRT",
      classNames: ["cellaStatoMag", "colTrovato"],
    },
    {
      when: (row) =>
        row["Corriere"] !== "DPD" &&
        row["stato"] === "PRONTO PER " + row["Corriere"],
      classNames: ["cellaStatoMag", "colTrovato"],
    },
    {
      when: (row) =>
        row["Corriere"] !== "DPD" &&
        row["stato"] &&
        row["stato"] !== "PRONTO PER " + row["Corriere"],
      classNames: ["cellaStatoMag", "colAnnullato"],
    },
    //rifare rifacendo corriere per corriere
  ];

  const nomeClienteAtteseCellStyles = [
    {
      when: (row) =>
        (row["userAttesa"] && row["userAttesa"] !== utente.username) ||
        (row["dataPromemoria"] && !dataMinoreDiOggi(row["dataPromemoria"])),
      // SE NE STA OCCUPANDO QUALCUN ALTRO O NON E' IL CASO DI FARLO ADESSO
      classNames: ["cellaClienteAttesa", "colAttesa"],
    },
    {
      when: (row) =>
        row["userAttesa"] &&
        row["userAttesa"] === utente.username &&
        (!row["dataPromemoria"] ||
          (row["dataPromemoria"] && dataMinoreDiOggi(row["dataPromemoria"]))),
      // ME NE DEVO OCCUPARE IO
      classNames: ["cellaClienteAttesa", "colProntoExp"],
    },
    {
      when: (row) => row["trovatoTutto"],
      // GLI ARTICOLI SONO TUTTI DISPONIBILI, L'ORDINE E' DA METTERE IN EXPORT
      classNames: ["cellaClienteAttesa", "colTrovato"],
    },
    {
      when: (row) => row["Tipo"] === "Invio per sostituzione",
      // GLI ARTICOLI SONO TUTTI DISPONIBILI, L'ORDINE E' DA METTERE IN EXPORT
      classNames: ["cellaClienteAttesa", "colAttesaSost"],
    },
    {
      when: (row) => row["Tipo"] === "Da controllare",
      // GLI ARTICOLI SONO TUTTI DISPONIBILI, L'ORDINE E' DA METTERE IN EXPORT
      classNames: ["cellaClienteAttesa", "colAttesaControllare"],
    },
    /* {
      when: row => row['Corriere'] !== 'DPD' && row['stato'] === "PRONTO PER "+row['Corriere'],
      classNames: ['cellaStatoMag', 'colEtichette']
    } */
  ];

  const statoGaranziaCellstyles = [
    {
      when: (row) =>
        row["statoGaranzia"] && row["statoGaranzia"].includes("ATTESA"),
      classNames: ["colAttesa"],
    },
    {
      when: (row) => row["statoGaranzia"] === "ACCETTATA",
      classNames: ["colSpedito"],
    },
    {
      when: (row) => row["statoGaranzia"] === "RICHIESTA CREATA",
      classNames: ["colEtichette"],
    },
    {
      when: (row) => row["statoGaranzia"] === "RIFIUTATA",
      classNames: ["colAnnullato"],
    },
  ];

  const garanzieGestiteCellStyle = [
    {
      when: (row) => row["gestito"] === 1,
      classNames: ["colEtichette"],
    },
  ];

  /////////////////// SELEZIONE COLONNE ////////////////////////////////

  const colonneLogistica = [
    //nomeDato,labelDato,width,sortable,hide,reorder,conditionalCellStyles,ignoreRowClick, sortField, compact
    nomeClientePS(
      "nomeCliente",
      "Nome",
      200,
      "id",
      "LOWER(sped.nomeCliente)",
      false,
    ),
    colonnaUniversale(
      "nomeCognomeSpedizione",
      "Destinatario",
      150,
      true,
      "sm",
      true,
      false,
      false,
      "LOWER(clif.NomeCognome)",
      false,
    ),
    colonnaUniversale(
      "Stato_Ordine",
      "Stato",
      140,
      true,
      false,
      true,
      statoOrdineCellstyles,
      false,
      "sped.Stato_Ordine",
      false,
    ),
    statoWebModaOrdine(170),
    {name:"Stato magazzino",width:"175px",cell:row=><div>{row.magazzino?.stato_magazzino?.replaceAll("_"," ") || "—"}
      {row.magazzino && <small className="db">{row.magazzino.pronti}/{row.magazzino.pezzi} pronti</small>}</div>},
    colonnaBoolean(
      "split",
      "S",
      40,
      "call_split",
      "",
      "sped.split",
      "scrittaColScuro",
      false,
      false,
    ),
    colonnaUniversale(
      "nazione",
      "Nazione",
      90,
      true,
      false,
      true,
      false,
      false,
      "clif.`Paese di provenienza`",
      true,
    ),
    colonnaUniversale(
      "Tipo",
      "Tipo",
      100,
      true,
      false,
      true,
      false,
      false,
      "sped.Tipo",
      false,
    ),
    colonnaUniversale(
      "fonte",
      "Fonte",
      58,
      true,
      false,
      true,
      fonteCellStyles,
      false,
      "sped.fonte",
      false,
    ),
    colonnaUniversale(
      "N_rif_PrestaShop",
      "PS",
      80,
      true,
      false,
      true,
      false,
      false,
      "cast(sped.N_rif_PrestaShop as unsigned)",
      false,
    ),
    /* colonnaUniversale('Market_Place','MP',100,true,false,true,marketplaceCellStyles,false,'sped.Market_Place'), */
    colonnaUniversale(
      "N_rif_MarketPlace",
      "rif MP",
      170,
      true,
      false,
      true,
      false,
      false,
      "sped.N_rif_MarketPlace",
      false,
    ),
    colonnaData("dataOrd", "Data Ordine", 100, "sped.`Data`"),
    colonnaImporto(
      "Tot_imp_spedizione",
      "tot.",
      100,
      "sped.Tot_imp_spedizione",
    ),
    colonnaUniversale(
      "Tipo_di_pagamento",
      "Tipo pagamento",
      140,
      true,
      false,
      true,
      marketplaceCellStyles,
      false,
      "sped.Tipo_di_pagamento",
      false,
    ),
    colonnaImporto(
      "Tot_imp_contrassegno",
      "Imp contrassegno",
      120,
      "sped.Tot_imp_contrassegno",
    ),
    colonnaUniversale(
      "Partenza_da",
      "Partenza da",
      120,
      true,
      false,
      true,
      false,
      false,
      "sped.Partenza_da",
      false,
    ),
    colonnaUniversale(
      "Corriere",
      "🚚",
      70,
      true,
      false,
      true,
      corriereCellStyles,
      false,
      "sped.Corriere",
      false,
    ),
    colonnaData("Data_partenza", "Data partenza", 130, "sped.Data_partenza"),
    colonnaBoolean(
      "Reso",
      "Reso",
      60,
      "done",
      "",
      "sped.Reso",
      "scrittaColScuro",
    ),
    /* colonnaBoolean('Rimborso', 'Rimb', 60, "done", '', 'sped.Rimborso', "scrittaColScuro"), */ //campo rimborso non è più valorizzato
    colonnaBoolean(
      "Promemoria",
      "Prom",
      60,
      "error",
      "",
      "sped.Promemoria",
      "scrittaRosso",
    ),
    colonnaUniversale(
      "tracking",
      "Tracking",
      100,
      true,
      false,
      true,
      false,
      false,
      "sped.N_Trakking",
      false,
    ),
    colonnaUniversale(
      "codicePUDO",
      "PUDO",
      150,
      true,
      false,
      true,
      false,
      false,
      "sped.codicePUDO",
      false,
    ),
    colonnaFlagArticoliOrdine(
      "inventory_sharing_ordine",
      "Inv. sharing",
      95,
      "statiModaOrdine.inventory_sharing_ordine",
    ),
    colonnaFlagArticoliOrdine(
      "dropshipping_ordine",
      "Dropship",
      90,
      "statiModaOrdine.dropshipping_ordine",
    ),
    colonnaUniversale(
      "stato",
      "Stato magazzino",
      120,
      true,
      false,
      true,
      false,
      false,
      "statoMag.stato",
      false,
    ),
    colonnaData("data", "Data s.m.", 120, "statoMag.data"),
    colonnaData(
      "Data_preparazione",
      "Data prep.",
      130,
      "sped.Data_preparazione",
    ),
    colonnaUniversale(
      "Emissione_scontrino",
      "Scontrino",
      120,
      true,
      false,
      true,
      false,
      false,
      "sped.Emissione_scontrino",
      false,
    ),
  ];

  const colonneArticoli = [
    //nomeDato,labelDato,width,sortable,hide,reorder,conditionalCellStyles,ignoreRowClick
    colonnaImmagine("imgIDps", "img", 100, "small_default"),
    descrizioneArticolo("desc", "Articolo", 600, "a.`Descrizione Articolo`"),
    colonnaUniversale(
      "codVS",
      "codVS",
      100,
      true,
      false,
      true,
      false,
      false,
      "cast(a.`Cod Viglietti Sport` as unsigned)",
      false,
    ),
    colonnaUniversale(
      "Produttore",
      "Produttore",
      150,
      true,
      false,
      true,
      false,
      false,
      "a.Produttore",
      false,
    ),
    colonnaUniversale(
      "quant",
      "pz",
      100,
      true,
      false,
      true,
      false,
      false,
      "a.`Quantità`",
      false,
    ),
    colonnaBooleanSenzaNull(
      "trovato",
      "trovato",
      60,
      "done",
      "close",
      "a.trovato",
      "br4 col-VERDE_SCURO",
      "br4 col-ROSSO",
    ),
    colonnaUniversale(
      "Stato_Ordine",
      "Stato",
      140,
      true,
      false,
      true,
      statoOrdineCellstyles,
      false,
      "sped.Stato_Ordine",
      false,
    ),
    colonnaBoolean(
      "split",
      "S",
      40,
      "call_split",
      "",
      "sped.split",
      "scrittaColScuro",
      false,
      false,
    ),
    nomeClientePS(
      "nomeCognome",
      "Nome",
      200,
      "idSped",
      "LOWER(clif.`NomeCognome`)",
      false,
    ),
    colonnaUniversale(
      "fonte",
      "Fonte",
      58,
      true,
      false,
      true,
      fonteCellStyles,
      false,
      "sped.fonte",
      false,
    ),
    colonnaUniversale(
      "N_rif_PrestaShop",
      "PS",
      80,
      true,
      false,
      true,
      false,
      false,
      "cast(sped.N_rif_PrestaShop as unsigned)",
      false,
    ),
    colonnaUniversale(
      "Partenza_da",
      "parte da",
      100,
      true,
      false,
      true,
      magPartenzaConflittoCellStyles,
      false,
      "sped.Partenza_da",
      false,
    ),
    statoWebModa(180),
    colonnaUniversale(
      "Corriere",
      "🚚",
      100,
      true,
      false,
      true,
      corriereCellStyles,
      false,
      "sped.Corriere",
      false,
    ),
    colonnaData("Data", "Data ordine", 120, "sped.Data"),
    colonnaData("Data_partenza", "Data partenza", 120, "sped.Data_partenza"),
    colonnaUniversale(
      "ean",
      "ean",
      150,
      true,
      false,
      true,
      false,
      false,
      "a.`Codice EAN`",
      false,
    ),
    colonnaUniversale(
      "Tipo_di_pagamento",
      "Tipo pagamento",
      100,
      true,
      false,
      true,
      marketplaceCellStyles,
      false,
      "sped.Tipo_di_pagamento",
      false,
    ),
    colonnaUniversale(
      "Market_Place",
      "Marketplace",
      100,
      true,
      false,
      true,
      false,
      false,
      "sped.Market_Place",
      false,
    ),
    colonnaBoolean(
      "inv_sharing",
      "Inv. sharing",
      80,
      "done",
      "close",
      "a.inv_sharing",
      "scrittaColScuro",
      false,
    ),
    colonnaBoolean(
      "dropshipping",
      "Dropship",
      75,
      "done",
      "close",
      "a.dropshipping",
      "scrittaColScuro",
      false,
    ),
    colonnaImporto("importo", "importo", 120, "a.`Importo unitario`"),
  ];

  const colonneEvasione = [
    colonnaUniversaleConCopiaValore(
      "ean",
      "ean",
      150,
      true,
      false,
      true,
      false,
      false,
      "a.`Codice EAN`",
      false,
    ),
    colonnaUniversale(
      "quant",
      "pz",
      100,
      true,
      false,
      true,
      false,
      false,
      "a.`Quantità`",
      false,
    ),
    colonnaImporto("importo", "importo", 120, "a.`Importo unitario`"),
    colonnaUniversale(
      "codVS",
      "codVS",
      100,
      true,
      false,
      true,
      false,
      false,
      "cast(a.`Cod Viglietti Sport` as unsigned)",
      false,
    ),

    colonnaUniversale(
      "Stato_Ordine",
      "Stato",
      140,
      true,
      false,
      true,
      statoOrdineCellstyles,
      false,
      "sped.Stato_Ordine",
      false,
    ),
    nomeClientePS(
      "nomeCognome",
      "Nome",
      200,
      "idSped",
      "LOWER(clif.`NomeCognome`)",
      false,
    ),
    colonnaUniversale(
      "N_rif_PrestaShop",
      "PS",
      80,
      true,
      false,
      true,
      false,
      false,
      "cast(sped.N_rif_PrestaShop as unsigned)",
      false,
    ),
    colonnaUniversale(
      "Partenza_da",
      "parte da",
      100,
      true,
      false,
      true,
      false,
      false,
      "sped.Partenza_da",
      false,
    ),
    colonnaData("Data_partenza", "Data partenza", 120, "sped.Data_partenza"),
    colonnaUniversale(
      "Emissione_scontrino",
      "Emissione scontrino",
      220,
      true,
      false,
      true,
      false,
      false,
      "sped.Emissione_scontrino",
      false,
    ),
    colonnaBooleanSenzaNullMODIFICA(
      "moda_trasferito",
      "TRA",
      60,
      "check",
      "close",
      "a.moda_trasferito",
      "scrittaVerde",
      "scrittaRossa",
      false,
      "moda_trasferito",
      "`ID Articolo`",
      "Articoli",
    ),
    colonnaBooleanSenzaNullMODIFICA(
      "moda_venduto",
      "VEN",
      60,
      "check",
      "close",
      "a.moda_venduto",
      "scrittaVerde",
      "scrittaRossa",
      false,
      "moda_venduto",
      "`ID Articolo`",
      "Articoli",
    ),
  ];

  const colonneArticoliStats = [
    //nomeDato,labelDato,width,sortable,hide,reorder,conditionalCellStyles,ignoreRowClick
    colonnaImmagine("imgIDps", "img", 100, "small_default"),
    descrizioneArticolo("desc", "Articolo", 500, "a.`Descrizione Articolo`"),
    colonnaUniversale(
      "codVS",
      "codVS",
      100,
      true,
      false,
      true,
      false,
      false,
      "cast(a.`Cod Viglietti Sport` as unsigned)",
      false,
    ),
    colonnaUniversale(
      "Produttore",
      "Produttore",
      150,
      true,
      false,
      true,
      false,
      false,
      "a.Produttore",
      false,
    ),
    colonnaUniversale(
      "quant",
      "pz",
      100,
      true,
      false,
      true,
      false,
      false,
      "a.`Quantità`",
      false,
    ),
    colonnaImporto("importo", "importo", 120, "a.`Importo unitario`"),
    colonnaData("Data_partenza", "Data partenza", 120, "sped.Data_partenza"),
    colonnaUniversale(
      "Tipo_di_pagamento",
      "Tipo pagamento",
      140,
      true,
      false,
      true,
      false,
      false,
      "sped.Tipo_di_pagamento",
      false,
    ),
    colonnaUniversale(
      "Market_Place",
      "Marketplace",
      100,
      true,
      false,
      true,
      false,
      false,
      "sped.Market_Place",
      false,
    ),
    colonnaUniversale(
      "N_rif_PrestaShop",
      "PS",
      80,
      true,
      false,
      true,
      false,
      false,
      "cast(sped.N_rif_PrestaShop as unsigned)",
      false,
    ),
    nomeClientePS(
      "nomeCognome",
      "Nome",
      200,
      "idSped",
      "LOWER(clif.`NomeCognome`)",
      false,
    ),
    colonnaData("Data", "Data ordine", 120, "sped.Data"),
    colonnaUniversale(
      "Partenza_da",
      "parte da",
      100,
      true,
      false,
      true,
      false,
      false,
      "sped.Partenza_da",
      false,
    ),
    colonnaUniversale(
      "Corriere",
      "🚚",
      100,
      true,
      false,
      true,
      false,
      false,
      "sped.Corriere",
      false,
    ),
    colonnaUniversale(
      "ean",
      "ean",
      150,
      true,
      false,
      true,
      false,
      false,
      "a.`Codice EAN`",
      false,
    ),
    colonnaUniversale(
      "Stato_Ordine",
      "Stato",
      140,
      true,
      false,
      true,
      false,
      false,
      "sped.Stato_Ordine",
      false,
    ),
  ];

  const colonneContabiliPAGAMENTI = [
    colonnaUniversale(
      "N_rif_PrestaShop",
      "Riferimento PS",
      150,
      true,
      false,
      true,
      false,
      false,
      "cast(sped.N_rif_PrestaShop as unsigned)",
      false,
    ),
    nomeClientePS(
      "nomeCliente",
      "Nome cliente",
      200,
      "id",
      "LOWER(sped.nomeCliente)",
      false,
    ),
    colonnaUniversale(
      "Tipo_di_pagamento",
      "Tipo pagamento",
      150,
      true,
      false,
      true,
      false,
      false,
      "sped.Tipo_di_pagamento",
      false,
    ),
    colonnaImporto(
      "Tot_imp_spedizione",
      "Tot. importo",
      100,
      "sped.Tot_imp_spedizione",
    ),
    colonnaImporto(
      "Spese_di_contrassegno",
      "Commissioni contrassegno",
      100,
      "sped.Spese_di_contrassegno",
    ),
    colonnaImporto(
      "Spese_di_spedizione",
      "Spese di spedizione",
      100,
      "sped.Spese_di_spedizione",
    ),
    colonnaData("dataOrd", "Data ordine", 130, "sped.`Data`"),
    colonnaData("Data_partenza", "Data partenza", 130, "sped.Data_partenza"),
    colonnaUniversale(
      "Stato_Ordine",
      "Stato ordine",
      150,
      true,
      false,
      true,
      false,
      false,
      "sped.Stato_Ordine",
      false,
    ),
    colonnaUniversale(
      "nazione",
      "Nazione",
      100,
      true,
      false,
      true,
      false,
      false,
      "cliFor`Paese di provenienza`",
      false,
    ),
    colonnaUniversale(
      "Market_Place",
      "MP",
      100,
      true,
      false,
      true,
      marketplaceCellStyles,
      false,
      "sped.Market_Place",
      false,
    ),
    colonnaUniversale(
      "N_rif_MarketPlace",
      "rif MP",
      170,
      true,
      false,
      true,
      false,
      false,
      "sped.N_rif_MarketPlace",
      false,
    ),
    colonnaBoolean("Reso", "Reso", 60, "done", "", "sped.Reso"),
    /* colonnaBoolean('Rimborso', 'Rimb', 60, "done", '', 'sped.Rimborso'), */ //campo rimborso non è più valorizzato
    colonnaUniversale(
      "Corriere",
      "🚚",
      100,
      true,
      false,
      true,
      corriereCellStyles,
      false,
      "sped.Corriere",
      false,
    ),
    colonnaUniversale(
      "Partenza_da",
      "Partenza da",
      120,
      true,
      false,
      true,
      false,
      false,
      "sped.Partenza_da",
      false,
    ),
    colonnaUniversale(
      "Emissione_scontrino",
      "Scontrino",
      120,
      true,
      false,
      true,
      false,
      false,
      "sped.Emissione_scontrino",
      false,
    ),
  ];

  const colonneControlliCorrispettivi = [
    colonnaData("dataOrd", "Data ordine", 130, "sped.`Data`"),
    nomeClientePS(
      "nomeCliente",
      "Nome cliente",
      200,
      "id",
      "LOWER(sped.nomeCliente)",
      false,
    ),
    colonnaUniversale(
      "fonte",
      "Fonte",
      70,
      true,
      false,
      true,
      fonteCellStyles,
      false,
      "sped.fonte",
      false,
    ),
    colonnaUniversale(
      "N_rif_PrestaShop",
      "Rif PS",
      130,
      true,
      false,
      true,
      false,
      false,
      "cast(sped.N_rif_PrestaShop as unsigned)",
      false,
    ),
    colonnaUniversale(
      "N_rif_MarketPlace",
      "Rif marketplace",
      180,
      true,
      false,
      true,
      false,
      false,
      "sped.N_rif_MarketPlace",
      false,
    ),
    colonnaUniversale(
      "Emissione_scontrino",
      "Scontrino",
      120,
      true,
      false,
      true,
      false,
      false,
      "sped.Emissione_scontrino",
      false,
    ),
    colonnaFileControlloCorrispettivi(),
    colonnaConfermaControlloCorrispettivi(),
    colonnaUniversale(
      "Tipo",
      "Tipo",
      100,
      true,
      false,
      true,
      false,
      false,
      "sped.Tipo",
      false,
    ),
    colonnaData("Data_partenza", "Data partenza", 130, "sped.Data_partenza"),
    colonnaUniversale(
      "Stato_Ordine",
      "Stato",
      140,
      true,
      false,
      true,
      statoOrdineCellstyles,
      false,
      "sped.Stato_Ordine",
      false,
    ),
  ];

  const colonneContabiliRIMBORSI = [
    colonnaUniversale(
      "N_rif_PrestaShop",
      "Riferimento PS",
      150,
      true,
      false,
      true,
      false,
      false,
      "cast(sped.N_rif_PrestaShop as unsigned)",
      false,
    ),
    nomeClientePS(
      "nomeCliente",
      "Nome cliente",
      200,
      "id",
      "LOWER(sped.nomeCliente)",
      false,
    ),
    colonnaUniversale(
      "Mezzo_rimborso",
      "Canale rimborso",
      150,
      true,
      false,
      true,
      false,
      false,
      "resi.Mezzo_rimborso",
      false,
    ),
    colonnaImporto(
      "Totale_rimborso",
      "Tot. rimborso",
      100,
      "resi.Totale_rimborso",
    ),
    colonnaImporto("Valore_merce", "Val. merce", 100, "resi.Valore_merce"),
    colonnaImporto("Spedizione_A", "Val. sped A", 100, "resi.Spedizione_A"),
    colonnaImporto("Spedizione_R", "Val sped R", 100, "resi.Spedizione_R"),
    colonnaData(
      "Data_operazione",
      "Data operazione",
      130,
      "resi.Data_operazione",
    ),
    colonnaData("Data_rientro", "Data rientro", 130, "resi.Data_rientro"),
    colonnaUniversale(
      "Emissione_scontrino",
      "Scontrino",
      120,
      true,
      false,
      true,
      false,
      false,
      "sped.Emissione_scontrino",
      false,
    ),
    colonnaUniversale(
      "Tipo_di_pagamento",
      "Tipo pagamento",
      150,
      true,
      false,
      true,
      false,
      false,
      "sped.Tipo_di_pagamento",
      false,
    ),
    colonnaImporto(
      "Tot_imp_spedizione",
      "Tot. importo",
      100,
      "sped.Tot_imp_spedizione",
    ),
    colonnaImporto(
      "Spese_di_contrassegno",
      "Commissioni contrassegno",
      100,
      "sped.Spese_di_contrassegno",
    ),
    colonnaImporto(
      "Spese_di_spedizione",
      "Spese di spedizione",
      100,
      "sped.Spese_di_spedizione",
    ),
    colonnaData("dataOrd", "Data ordine", 130, "sped.`Data`"),
    colonnaData("Data_partenza", "Data partenza", 130, "sped.Data_partenza"),
    colonnaUniversale(
      "Partenza_da",
      "Partenza da",
      120,
      true,
      false,
      true,
      false,
      false,
      "sped.Partenza_da",
      false,
    ),
    colonnaUniversale(
      "Stato_Ordine",
      "Stato ordine",
      150,
      true,
      false,
      true,
      false,
      false,
      "sped.Stato_Ordine",
      false,
    ),
    colonnaUniversale(
      "nazione",
      "Nazione",
      100,
      true,
      false,
      true,
      false,
      false,
      "cliFor`Paese di provenienza`",
      false,
    ),
    colonnaUniversale(
      "Market_Place",
      "MP",
      100,
      true,
      false,
      true,
      marketplaceCellStyles,
      false,
      "sped.Market_Place",
      false,
    ),
    colonnaUniversale(
      "N_rif_MarketPlace",
      "rif MP",
      170,
      true,
      false,
      true,
      false,
      false,
      "sped.N_rif_MarketPlace",
      false,
    ),
    colonnaBoolean("Reso", "Reso", 60, "done", "", "sped.Reso"),
    /* colonnaBoolean('Rimborso', 'Rimb', 60, "done", '', 'sped.Rimborso') */ //campo rimborso non è più valorizzato
  ];

  const colonnaNoteOrdini = colonnaArrayDiNote(
    "noteArr",
    "Note",
    350,
    false,
    "sm",
    true,
    false,
    false,
    false,
    true,
  );

  const colonneDaNascondereInNote = new Set([
    "tot.",
    "Tipo pagamento",
    "Data partenza",
    "Reso",
    "Tracking",
    "Inv. sharing",
    "Dropship",
    "Stato magazzino",
    "Data s.m.",
    "Data prep.",
    "Scontrino",
  ]);

  const colonneLogisticaConNote = colonneLogistica
    .filter((colonna) => !colonneDaNascondereInNote.has(colonna.name))
    .flatMap((colonna) =>
      colonna.name === "S" ? [colonna, colonnaNoteOrdini] : [colonna],
    );

  const colonneAttese = [
    //nomeDato,labelDato,width,sortable,hide,reorder,conditionalCellStyles,ignoreRowClick
    colonnaUniversale(
      "id",
      "id",
      50,
      true,
      "sm",
      true,
      false,
      false,
      "sped.`ID Spedizione`",
      true,
    ),
    immagineUtente(
      "userAttesa",
      "in carico",
      80,
      "sped.userAttesa",
      false,
      true,
    ),
    nomeClientePS(
      "nomeCliente",
      "Nome",
      200,
      "id",
      "LOWER(sped.nomeCliente)",
      false,
      nomeClienteAtteseCellStyles,
    ),
    colonnaUniversale(
      "N_rif_PrestaShop",
      "PS",
      80,
      true,
      false,
      true,
      false,
      false,
      "cast(sped.N_rif_PrestaShop as unsigned)",
      false,
    ),
    colonnaBooleanSenzaNull(
      "trovatoTutto",
      "trovati",
      60,
      "done",
      "close",
      "a.trovato",
      "br4 col-VERDE_SCURO",
      "br4 col-ROSSO",
      true,
    ),
    /* colonnaUniversale('nazione', 'Nazione', 100, true, false, true, false, false, 'clif.\`Paese di provenienza\`', false), */
    /* colonnaUniversale('Tipo', 'Tipo', 120, true, false, true, false, false, 'sped.Tipo', false),     */
    colonnaUniversale(
      "N_rif_MarketPlace",
      "rif MP",
      170,
      true,
      false,
      true,
      false,
      false,
      "sped.N_rif_MarketPlace",
      false,
    ),
    colonnaData("dataOrd", "Data Ordine", 100, "sped.`Data`"),
    /* colonnaImporto('Tot_imp_spedizione', 'tot.', 100, 'sped.Tot_imp_spedizione'), */
    colonnaUniversale(
      "Tipo_di_pagamento",
      "Tipo pagamento",
      140,
      true,
      false,
      true,
      marketplaceCellStyles,
      false,
      "sped.Tipo_di_pagamento",
      false,
    ),
    colonnaBoolean(
      "Rimborso",
      "Rimb",
      60,
      "done",
      "",
      "sped.Rimborso",
      "scrittaColScuro",
    ),
    colonnaBoolean(
      "Promemoria",
      "Prom",
      60,
      "error",
      "",
      "sped.Promemoria",
      "scrittaRosso",
    ),
    colonnaData(
      "dataPromemoria",
      "Ricordamelo",
      100,
      "sped.`dataPromemoria`",
      true,
    ),
    colonnaBoolean(
      "ricordamelo",
      "Notifica",
      70,
      "schedule",
      "",
      "sped.Promemoria",
      "scrittaColScuro",
    ),
    colonnaArrayDiArticoli(
      "arrCodiciArticoli",
      "articoli",
      400,
      false,
      "sm",
      true,
      false,
      false,
      false,
      "done",
      "close",
      "br4 col-VERDE_SCURO",
      "br4 col-ROSSO",
      true,
    ),
    colonnaArrayDiNote(
      "noteArr",
      "note",
      350,
      false,
      "sm",
      true,
      false,
      false,
      false,
      true,
    ),
    /* noteToolTipAvatarUtenti('noteArr', 'Note', 400), */
  ];

  const colonneCheckSparati = [
    colonnaUniversale(
      "N_rif_PrestaShop",
      "PS",
      80,
      true,
      false,
      true,
      false,
      false,
      "cast(sped.N_rif_PrestaShop as unsigned)",
      false,
    ),
    nomeClientePS(
      "nomeCognomeSpedizione",
      "Nome",
      200,
      "id",
      "LOWER(clif.NomeCognome)",
      false,
    ),
    colonnaUniversale(
      "Corriere",
      "🚚",
      70,
      true,
      false,
      true,
      corriereCellStyles,
      false,
      "sped.Corriere",
      false,
    ),
    colonnaUniversale(
      "stato",
      "Stato magazzino",
      160,
      true,
      false,
      true,
      statoMagCellStyles,
      false,
      "statoMag.stato",
      false,
    ),
    colonnaData("data", "Data s.m.", 120, "statoMag.data"),
    noteToolTipAvatarUtenti("noteArr", "Note", 160),
  ];

  const colonneMobileLogistica = [
    colonnaUniversale(
      "N_rif_PrestaShop",
      "PS",
      80,
      true,
      false,
      true,
      false,
      false,
      "cast(sped.N_rif_PrestaShop as unsigned)",
      true,
    ),
    nomeClientePS(
      "nomeCliente",
      "Nome",
      120,
      "id",
      "LOWER(sped.nomeCliente)",
      true,
    ),
    colonnaUniversale(
      "Stato_Ordine",
      "Stato",
      50,
      true,
      false,
      true,
      statoOrdineCellstyles,
      false,
      "sped.Stato_Ordine",
      true,
    ),
    colonnaFlagArticoliOrdine(
      "inventory_sharing_ordine",
      "IS",
      55,
      "statiModaOrdine.inventory_sharing_ordine",
    ),
    colonnaFlagArticoliOrdine(
      "dropshipping_ordine",
      "DS",
      55,
      "statiModaOrdine.dropshipping_ordine",
    ),
    colonnaUniversale(
      "Partenza_da",
      "Partenza da",
      50,
      true,
      false,
      true,
      false,
      false,
      "sped.Partenza_da",
      true,
    ),
    colonnaData("Data_partenza", "Data partenza", 130, "sped.Data_partenza"),
    colonnaUniversale(
      "Tipo",
      "Tipo",
      70,
      true,
      false,
      true,
      false,
      false,
      "sped.Tipo",
      true,
    ),
  ];

  const colonneMobileArticoli = [
    //nomeDato,labelDato,width,sortable,hide,reorder,conditionalCellStyles,ignoreRowClick
    colonnaImmagine("imgIDps", "img", 70, "small_default", true),
    colonnaUniversale(
      "fonte",
      "Fonte",
      45,
      true,
      false,
      true,
      fonteCellStyles,
      false,
      "sped.fonte",
      true,
    ),
    colonnaUniversale(
      "codVS",
      "cod",
      50,
      true,
      false,
      true,
      false,
      false,
      "cast(a.`Cod Viglietti Sport` as unsigned)",
      true,
    ),
    colonnaUniversale(
      "Produttore",
      "brand",
      100,
      true,
      false,
      true,
      false,
      false,
      "a.Produttore",
      true,
    ),
    colonnaUniversale(
      "quant",
      "n.",
      30,
      true,
      false,
      true,
      false,
      false,
      "a.`Quantità`",
      true,
    ),
    colonnaBooleanSenzaNull(
      "trovato",
      "trovato",
      50,
      "done",
      "close",
      "a.trovato",
      "br4 col-VERDE_SCURO",
      "br4 col-ROSSO",
    ),
    colonnaBoolean(
      "inv_sharing",
      "IS",
      45,
      "done",
      "close",
      "a.inv_sharing",
      "scrittaColScuro",
      false,
    ),
    colonnaBoolean(
      "dropshipping",
      "DS",
      45,
      "done",
      "close",
      "a.dropshipping",
      "scrittaColScuro",
      false,
    ),
    /* nomeClientePS('nomeCognome', 'Nome', 200, 'idSped', 'LOWER(clif.\`NomeCognome\`)'),
    colonnaUniversale('N_rif_PrestaShop', 'PS', 70, true, false, true, false, false, 'cast(sped.N_rif_PrestaShop as unsigned)', false), */
    /* colonnaUniversale('Partenza_da', 'parte da', 100, true, false, true, false, false, 'sped.Partenza_da', false),
    colonnaUniversale('Corriere', '🚚', 100, true, false, true, corriereCellStyles, false, 'sped.Corriere', false),
    colonnaData('Data', 'Data ordine', 120, 'sped.Data'),,
    colonnaData('Data_partenza', 'Data partenza', 120, 'sped.Data_partenza'), */
  ];

  const colonneGaranzie = [
    garanziaCliccabile(
      "nomeCliente",
      "Nome",
      200,
      "id",
      "LOWER(sped.nomeCliente)",
      false,
    ),
    colonnaUniversale(
      "idSpedPS",
      "Ordine",
      100,
      true,
      false,
      true,
      false,
      false,
      "cast(sped.N_rif_PrestaShop as unsigned)",
      false,
    ),
    colonnaUniversale(
      "nomeBrand",
      "Brand",
      150,
      true,
      false,
      true,
      false,
      false,
      "gar.nomeBrand",
      false,
    ),
    colonnaUniversale(
      "codiceArticolo",
      "Cod.Art",
      100,
      true,
      false,
      true,
      false,
      false,
      "gar.codiceArticolo",
      false,
    ),
    colonnaUniversale(
      "nomeArticolo",
      "Articolo",
      300,
      true,
      false,
      true,
      false,
      false,
      "gar.nomeArticolo",
      false,
    ),
    colonnaData(
      "dataRichiestaGaranzia",
      "Data Garanzia",
      100,
      "gar.dataRichiestaGaranzia",
    ),
    colonnaData("dataOrd", "Data Ordine", 100, "sped.`Data`"),
    colonnaUniversale(
      "codGaranziaProduttore",
      "Cod garanzia",
      200,
      true,
      false,
      true,
      false,
      false,
      "gar.codGaranziaProduttore",
      false,
    ),
    colonnaUniversale(
      "statoGaranzia",
      "Stato",
      200,
      true,
      false,
      true,
      statoGaranziaCellstyles,
      false,
      "gar.statoGaranzia",
      false,
    ),
    colonnaBoolean(
      "gestito",
      "gestito",
      100,
      "done",
      "",
      "gar.gestito",
      "scrittaColScuro",
      garanzieGestiteCellStyle,
      true,
    ),
  ];

  const colonneAnteprimaOrdiniGaranzie = [
    colonnaUniversale(
      "N_rif_PrestaShop",
      "PS",
      40,
      true,
      false,
      true,
      false,
      false,
      "cast(sped.N_rif_PrestaShop as unsigned)",
      true,
    ),
    nomeClientePS(
      "nomeCliente",
      "Nome",
      120,
      "id",
      "LOWER(sped.nomeCliente)",
      true,
    ),
    colonnaUniversale(
      "Stato_Ordine",
      "Stato",
      130,
      true,
      false,
      true,
      statoOrdineCellstyles,
      false,
      "sped.Stato_Ordine",
      false,
    ),
    colonnaData("Data_partenza", "Data partenza", 130, "sped.Data_partenza"),
    colonnaUniversale(
      "Tipo",
      "Tipo",
      90,
      true,
      false,
      true,
      false,
      false,
      "sped.Tipo",
      true,
    ),
    scegliID("id", "", 110, "id", "sped.id", false),
  ];

  let columns = colonneLogistica;

  if (mobile) {
    columns = colonneMobileLogistica;
    expandableRows = true;
    expandableRowsComponent = expandedRowOrdineMobile;
    /* expandableRowExpanded={(row) => (row === currentRow)} */
  }

  if (!vista && !perPage) {
    /* if (mobile) {
      columns = colonneMobileLogistica
    } else {
      columns = colonneLogistica;
    }     */
  } else if (vista === "contabili") {
    columns = colonneContabiliPAGAMENTI;
  } else if (vista === "articoli") {
    if (mobile) {
      columns = colonneMobileArticoli;
      expandableRows = true;
      expandableRowsComponent = expandedRowArticoloMobile;
      rowPreExpanded = (row) => row.id;
    } else {
      columns = colonneArticoli;
    }
    striped = false;
  } else if (vista === "note") {
    columns = colonneLogisticaConNote;
  } else if (vista === "checkSparati") {
    columns = colonneCheckSparati;
    striped = false;
    selectableRows = false;
    if (colonna && colonna === "1") {
      fixedHeader = true;
      fixedHeaderScrollHeight = "750px";
    }
  } else if (vista === "controlliCorrispettivi") {
    columns = colonneControlliCorrispettivi;
    selectableRows = false;
  } else if (vista === "contabiliRimborsi") {
    columns = colonneContabiliRIMBORSI;
  } else if (vista === "attese") {
    columns = colonneAttese;
    selectableRows = false;
  } else if (vista === "garanzie") {
    columns = colonneGaranzie;
    selectableRows = false;
  } else if (vista === "anteprimaOrdiniGaranzie") {
    columns = colonneAnteprimaOrdiniGaranzie;
    selectableRows = false;
  } else if (vista === "evasione") {
    columns = colonneEvasione;
    selectableRows = true;
  }

  if (report) {
    columns = colonneArticoliStats;
    paginationRowsPerPageOptions = [10, 50, 100, 200];
    selectableRows = false;
  }

  if (mobile) {
    selectableRows = false;
  }

  const personalizzaOrdini = Boolean(enableOrdiniColumns) && (!vista || vista === "ordini") && !mobile && !report;
  if (personalizzaOrdini) {
    const identified = identificaColonneOrdini(colonneLogistica);
    columns = normalizeColumnOrder(ordiniColumnOrder, ORDINI_COLUMN_IDS, ORDINI_LOCKED_COLUMN_IDS)
      .map((id) => identified.find((column) => column.id === id)).map((column) => ({
      ...column,
      omit: ordiniColumnVisibility?.[column.id] === false && column.id !== "nomeCliente",
      reorder: Boolean(onOrdiniColumnOrderChange) && !ORDINI_LOCKED_COLUMN_IDS.includes(column.id),
    }));
  }

  // La libreria permette il drop anche su una colonna con reorder:false.
  // Blocchiamo quei target prima che il suo handler sposti il Nome cliente.
  const guardColumnDrag = (event) => {
    const header = event.target.closest?.(".rdt_TableCol");
    if (!onOrdiniColumnOrderChange || !header?.closest(".rdt_TableHeadRow") ||
        !ORDINI_COLUMN_IDS.includes(header.dataset.columnId) ||
        ORDINI_LOCKED_COLUMN_IDS.includes(header.dataset.columnId)) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  // La larghezza del checkbox viene dal layout reale di DataTableBase.
  useEffect(() => {
    if (!personalizzaOrdini || !tableRef.current) return undefined;
    const selection = tableRef.current.querySelector(".rdt_TableHeadRow > .rdt_TableCol:first-child");
    if (!selection) return undefined;
    const update = () => tableRef.current?.style.setProperty(
      "--ordini-selection-width", `${selection.getBoundingClientRect().width}px`,
    );
    update();
    if (typeof ResizeObserver !== "undefined") {
      const observer = new ResizeObserver(update);
      observer.observe(selection);
      return () => observer.disconnect();
    }
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, [personalizzaOrdini, loading]);

  return (
    <div ref={tableRef} className={`colonna95vh tabelleOrdini${personalizzaOrdini ? " ordini-colonne-sticky" : ""}`}
      onDragStartCapture={personalizzaOrdini ? guardColumnDrag : undefined}
      onDragEnterCapture={personalizzaOrdini ? guardColumnDrag : undefined}>
      {/* <h3>{mobile ? "sì" : "no"}</h3> */}
      {mobile && (
        <div className="tc db dn-ns pt3 f4">
          {pagineDefault} su <strong>{totalRows}</strong> ordini{" "}
        </div>
      )}
      {mobile && ricerca && (
        <div className="tc pb3 b f4 flex justify-center">
          <div className="mr2 ml2">{ricerca["sped.Partenza_da ="]}</div>
          <div className="mr2 ml2">{ricerca["sped.Stato_Ordine ="]}</div>
        </div>
      )}
      <DataTable
        data={rows}
        columns={columns}
        onColumnOrderChange={personalizzaOrdini && onOrdiniColumnOrderChange
          ? (nextColumns) => onOrdiniColumnOrderChange(normalizeColumnOrder(
            nextColumns.map((column) => column.id), ORDINI_COLUMN_IDS, ORDINI_LOCKED_COLUMN_IDS,
          )) : undefined}
        clearSelectedRows={deseleziona}
        fixedHeader={fixedHeader}
        fixedHeaderScrollHeight={fixedHeaderScrollHeight}
        striped={striped}
        onSort={handleSort}
        paginationDefaultPage={page ? page : 1}
        expandableRows={expandableRows}
        expandableRowsComponent={expandableRowsComponent}
        expandableRowExpanded={rowPreExpanded}
        expandOnRowClicked={expandOnRowClicked}
        expandOnRowDoubleClicked={expandOnRowDoubleClicked}
        expandableRowsHideExpander={expandableRowsHideExpander}
        sortServer
        selectableRows={selectableRows}
        selectableRowsHighlight
        onSelectedRowsChange={handleChangeRigheSelezionate}
        progressPending={loading}
        noDataComponent={
          <h3 className="ma5 pa5">Nessun ordine risponde alla tua ricerca.</h3>
        }
        progressComponent={
          utente.nomeDisplayAlt === "Manu" ||
          utente.nomeDisplayAlt === "Ribes" ||
          utente.nomeDisplayAlt === "Mari" ? (
            <img alt="loading" className="w-10" src={chickenLoading} />
          ) : (
            <h3 className="ma5 pa5 ">carico i dati...</h3>
          )
        }
        pagination
        paginationRowsPerPageOptions={paginationRowsPerPageOptions}
        paginationPerPage={pagineDefault}
        paginationServer
        paginationTotalRows={totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        paginationServerOptions={{
          persistSelectedOnPageChange: true,
          persistSelectedOnSort: true,
        }}
        paginationComponentOptions={{
          rowsPerPageText: "Ordini per pagina:",
          rangeSeparatorText: "di",
          noRowsPerPage: false,
          selectAllRowsItem: false,
          selectAllRowsItemText: "Seleziona tutti",
        }}
      />
    </div>
  );
}

export default ListaOrdini;
